'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Neptune.complete = {
  init: function init() {
    _n.qsa('[oncomplete]:not(.completeable)').forEach(function (input) {
      input.classList.add('completeable');
      input.typingTimer = input.typingTimer || {};
      input.addEventListener('keydown', function (event) {
        clearTimeout(input.typingTimer);
      });
      input.addEventListener('keyup', function (event) {
        var _this = { value: input.value };
        clearTimeout(input.typingTimer);
        input.typingTimer = setTimeout(function () {
          eval(input.getAttribute('oncomplete').replace(/this/g, '_this'));
        }, 500);
      });
    });
  }
};

window.Neptune = Neptune;

exports.default = Neptune.complete;